module.exports = ":host ::ng-deep mat-super-select mat-form-field {\n  width: 100%; }\n"